import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { ShoppingBag, ArrowRight, Package } from 'lucide-react';

const naira = (n) => `₦${Number(n || 0).toLocaleString()}`;

const STATUS_COLORS = {
  paid: 'bg-green-100 text-green-800',
  completed: 'bg-green-100 text-green-800',
  delivered: 'bg-green-100 text-green-800',
  shipped: 'bg-blue-100 text-blue-800',
  pending: 'bg-amber-100 text-amber-800',
  unpaid: 'bg-amber-100 text-amber-800',
  cancelled: 'bg-red-100 text-red-800',
  refunded: 'bg-gray-100 text-gray-700',
};

const OrdersSection = ({ orders }) => {
  if (!orders || orders.length === 0) {
    return (
      <Card data-testid="orders-empty">
        <CardContent className="p-8 text-center">
          <div className="w-14 h-14 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-3">
            <ShoppingBag className="h-6 w-6 text-green-600" aria-hidden="true" />
          </div>
          <p className="font-semibold">No orders yet</p>
          <p className="text-sm text-gray-500 mb-4">Shop fresh produce delivered nationwide.</p>
          <Link to="/shop">
            <Button className="bg-green-600 hover:bg-green-700">
              Visit shop <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
          </Link>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card data-testid="orders-section">
      <CardContent className="p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="font-semibold text-lg">Recent Orders</h2>
            <p className="text-xs text-gray-500">{orders.length} total</p>
          </div>
          <Link to="/track-order">
            <Button variant="ghost" size="sm">Track order</Button>
          </Link>
        </div>
        <div className="space-y-2">
          {orders.slice(0, 5).map((o) => {
            const s = (o.status || o.payment_status || '').toLowerCase();
            return (
              <div
                key={o._id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
                data-testid={`order-row-${o._id}`}
              >
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-9 h-9 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                    <Package className="h-4 w-4 text-gray-500" aria-hidden="true" />
                  </div>
                  <div className="min-w-0">
                    <p className="font-medium text-sm truncate">Order {o.order_number}</p>
                    <p className="text-xs text-gray-500">
                      {new Date(o.created_at).toLocaleDateString()} · {(o.items || []).length} items
                    </p>
                  </div>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="font-semibold text-sm">{naira(o.total_amount)}</p>
                  <Badge className={`${STATUS_COLORS[s] || 'bg-gray-100 text-gray-700'} border-none text-[10px]`}>
                    {o.status || o.payment_status || 'unknown'}
                  </Badge>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default OrdersSection;
